'use client';
import React, { useState, useMemo, createContext, useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from "react-transition-group";

import Icons from "./Icons"
import { generateUEID } from "../utils/helpers";

const ToastContext = createContext(null);

function Toast(props: any) {
  return (
    <div className={"loop-toast " + (props.type == 'success' ? "success" : props.type == "failure" ? "failure" : "default")}>
      <div className="d-flex align-items-center w-100">
        {props.icon ? (
          <div className="loop-toast-image">
            <img src={props.icon} alt="" />
          </div>
        ) : null}
        <div className="loop-toast-message flex-grow-1">{props.message}</div>
        <div className="d-flex justify-content-center align-items-center mx-2" onClick={props.close}><Icons.Cancel /></div>
      </div>
    </div>
  );
}

export function ToastProvider(props: any) {
  const [toasts, settoasts] = useState([]);
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  const open = (toastConfig: any) => {
    let _id = generateUEID();
    settoasts((currentToasts) => [
      ...currentToasts,
      { id: _id, message: toastConfig.message, active: true, type: toastConfig.type },
    ]);

    if (toastConfig.time) {
      setTimeout(() => {
        close(_id)
      }, toastConfig.time)
    }
  }

  const close = (id: string) => {
    settoasts((currentToasts) =>
      currentToasts.map((toast: any) => { return { ...toast, active: toast.id == id ? false : true } })
    );
    setTimeout(() => {
      settoasts((currentToasts) =>
        currentToasts.filter((toast: any) => toast.id != id)
      );
    }, 500)
  }

  const contextValue = useMemo(() => ({ open }), []);

  return (
    <ToastContext.Provider value={contextValue}>
      {props.children}
      {mounted ? createPortal(
        <div className="loop loop-toasts-wrapper">
          {toasts.map((toast: any, i: number) => (
            <CSSTransition
              key={i}
              in={toast.active}
              appear={true}
              unmountOnExit={true}
              timeout={{ enter: 0, exit: 200 }}
            >
              <Toast key={toast.id} close={() => close(toast.id)} message={toast.message} type={toast.type} />
            </CSSTransition>
          ))}
        </div>,
        document.body
      ) : null}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);